// export const googleMapKey = "AIzaSyCfr1DSbdVYM00EZvCFgxHhKpS0ISJtMCU" // Testing key
export const googleMapKey = "AIzaSyBhsu2tPSwSPWJFRdqHVjJ3YsDC9sBaKSM" // Production key